import MarkdownCMSModule from '@/cmsComponents/MarkdownCMSModule';
import React from 'react';
import { FormDisclaimer } from 'types/cms';

import styles from './style.module.scss';

/**
 * Read-only disclaimer text for a Form e.g 'By submitting, you are agreeing to our terms and conditions"
 * @param disclaimer the markdown text that should be rendered. Probably configured in the CMS
 * @constructor
 */
export const Disclaimer = ({ disclaimer }: FormDisclaimer) => {
  return (
    <div className={styles.disclaimer}>
      <MarkdownCMSModule source={disclaimer || ''} />
    </div>
  );
};

export default Disclaimer;
